import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';

ReactDOM.render(<App/>, document.getElementById('root'));
if (navigator.serviceWorker) {
  navigator.serviceWorker.register('/service_worker.js')
}




// WEBPACK FOOTER //
// ./src/index.js